/**
 * algolia-tabs.js
 * Products / Articles tab switcher for the Olay search results page.
 *
 * Strategy (simple & reliable):
 *  - Products tab: show the Algolia InstantSearch section, hide articles panel.
 *  - Articles tab: hide the Algolia InstantSearch section, show articles panel.
 *
 * [data-panel="articles"] lives in the DOM as a standalone full-width element
 * (sibling of the Algolia section) and is NEVER moved by JS, so
 * algolia-articles-search.js always finds it in a stable position.
 */
(function () {
  'use strict';

  var _initial = 'products';
  try {
    _initial = new URL(window.location.href).searchParams.get('tab') || 'products';
  } catch (_) {}

  var _currentTab = _initial;

  /* ── ALGOLIA SYNC ──────────────────────────────────────── */
  function syncToAlgolia(value) {
    var aisInput = document.querySelector('#algolia-shopify-instantsearch .ais-SearchBox-input');
    if (!aisInput) return;
    try {
      var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      if (nativeSetter) nativeSetter.call(aisInput, value);
    } catch (_) {
      aisInput.value = value;
    }
    aisInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ── TAB SWITCHING ──────────────────────────────────────── */
  function setActiveTab(tab) {
    _currentTab = tab;

    /* 1. Update button aria/class */
    document.querySelectorAll('[data-algolia-tabs] [data-tab]').forEach(function (btn) {
      var active = btn.dataset.tab === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    /* 2. Toggle Algolia InstantSearch section visibility.
          Target the .shopify-section wrapper so no ghost height remains. */
    var aisContainer = document.getElementById('algolia-shopify-instantsearch');
    if (aisContainer) {
      var aisSection = aisContainer.closest('.shopify-section') || aisContainer;
      if (tab === 'products') {
        aisSection.style.removeProperty('display');
        /* Sync shared search value into Algolia when switching to products tab */
        var sharedInput = document.querySelector('.olay-shared-search__input');
        if (sharedInput) syncToAlgolia(sharedInput.value);
      } else {
        aisSection.style.setProperty('display', 'none', 'important');
      }
    }

    /* 3. Toggle articles panel */
    var articlesPanel = document.querySelector('[data-panel="articles"]');
    if (articlesPanel) {
      articlesPanel.hidden = (tab !== 'articles');
    }

    /* 4. Persist in URL */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('tab', tab);
      history.replaceState({}, '', url.toString());
    } catch (_) {}
  }

  /* ── INIT ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-algolia-tabs]')) return;

    /* Set up shared search bar */
    var sharedInput = document.querySelector('.olay-shared-search__input');
    if (sharedInput) {
      /* Pre-fill from URL ?q= param */
      try {
        var urlQ = new URL(window.location.href).searchParams.get('q');
        if (urlQ) sharedInput.value = urlQ;
      } catch (_) {}

      /* Sync to Algolia products on keystroke */
      sharedInput.addEventListener('input', function () {
        if (_currentTab === 'products') syncToAlgolia(sharedInput.value);
      });

      /* Prevent form navigation on submit; trigger sync */
      var searchForm = sharedInput.closest('form');
      if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (_currentTab === 'products') syncToAlgolia(sharedInput.value);
        });
      }
    }

    /* Apply initial tab from URL */
    setActiveTab(_initial);

    /* Click delegation — single listener on document */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab]');
      if (!btn || !btn.closest('[data-algolia-tabs]')) return;
      setActiveTab(btn.dataset.tab);
    });
  });
})();


